import { render, staticRenderFns } from "./filter-project-parts.vue?vue&type=template&id=d1cda452&scoped=true"
import script from "./filter-project-parts.vue?vue&type=script&lang=ts"
export * from "./filter-project-parts.vue?vue&type=script&lang=ts"
import style0 from "./filter-project-parts.vue?vue&type=style&index=0&id=d1cda452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cda452",
  null
  
)

export default component.exports